  $(document).ready(function() {
    // Initialize Image Swiper
    const activitiesSwiper = new Swiper('.activities-swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      allowTouchMove: true,
      effect: 'slide',
      speed: 800,
      on: {
        slideChange: function() {
          // Sync content swiper with image swiper
          contentSwiper.slideTo(this.activeIndex);
          updateActiveIcon(this.activeIndex);
        }
      }
    });

    // Initialize Content Swiper
    const contentSwiper = new Swiper('.activities-content-swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      allowTouchMove: true,
      effect: 'slide',
      speed: 800,
      on: {
        slideChange: function() {
          // Sync image swiper with content swiper
          activitiesSwiper.slideTo(this.activeIndex);
          updateActiveIcon(this.activeIndex);
        }
      }
    });

    // Activity icon click and hover handlers
    $('.activity-icon-item').each(function(index) {
      $(this).on('click', function() {
        // Sync both swipers
        activitiesSwiper.slideTo(index);
        contentSwiper.slideTo(index);
        updateActiveIcon(index);
        // Sync shop discounts slide
        syncShopDiscountsSlide(index);
      });

      // Add hover handler to switch slides and sync shop discounts
      $(this).on('mouseenter', function() {
        // Sync both swipers
        activitiesSwiper.slideTo(index);
        contentSwiper.slideTo(index);
        updateActiveIcon(index);
        // Also sync shop discounts slide on hover
        syncShopDiscountsSlide(index);
      });
    });

    // Update active icon state
    function updateActiveIcon(activeIndex) {
      $('.activity-icon-item').each(function(index) {
        if (index === activeIndex) {
          $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
      });
    }

    // Set initial active state
    if ($('.activity-icon-item').length > 0) {
      updateActiveIcon(0);
    }
  });

  // Function to sync shop discounts slide with activities hover/click
  function syncShopDiscountsSlide(activityIndex) {
    // Only handle Shop (index 0) and Food (index 1)
    if (activityIndex !== 0 && activityIndex !== 1) {
      return;
    }
    
    let targetSlideIndex = 0;
    
    // Map activities slide index to shop discounts slide index
    // Shop (index 0) -> slide 1 (index 0), Food (index 1) -> slide 2 (index 1)
    if (activityIndex === 0) {
      targetSlideIndex = 0;
    } else if (activityIndex === 1) {
      targetSlideIndex = 1;
    }
    
    // Only sync if shop discounts section is already visible
    const $discountsSection = $('#shop-discounts-section');
    if ($discountsSection.length && $discountsSection.css('display') !== 'none') {
      // Directly slide the brands swiper without opening/closing
      const brandsSwiperEl = document.querySelector('.brands-swiper');
      if (brandsSwiperEl && brandsSwiperEl.swiper) {
        brandsSwiperEl.swiper.slideTo(targetSlideIndex);
      }
    }
  }

  // Updated function to toggle shop discounts section
  function toggleParticipatingBrands() {
    // Get the current active slide index from the content swiper
    let targetSlideIndex = 0;
    const contentSwiperEl = document.querySelector('.activities-content-swiper');
    
    if (contentSwiperEl && contentSwiperEl.swiper) {
      const activeIndex = contentSwiperEl.swiper.activeIndex;
      
      // Map activities slide index to shop discounts slide index
      if (activeIndex === 0) {
        targetSlideIndex = 0;
      } else if (activeIndex === 1) {
        targetSlideIndex = 1;
      }
    }
    
    // Call the global toggleShopDiscounts function with the target slide index
    if (typeof toggleShopDiscounts === 'function') {
      toggleShopDiscounts(targetSlideIndex);
    } else {
      console.warn('toggleShopDiscounts function not found. Make sure Shop Discounts section is on the page.');
    }
  }
